import { render } from "./DetalheComponent.vue?vue&type=template&id=439920fa&scoped=true"
import script from "./DetalheComponent.vue?vue&type=script&lang=js"
export * from "./DetalheComponent.vue?vue&type=script&lang=js"

import "./DetalheComponent.vue?vue&type=style&index=0&id=439920fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439920fa"]])

export default __exports__